import { IMAGES } from "../assets";

export const LANGUAGES = [
  { id: 1, text: "Angular", src: IMAGES.IconAngular },
  { id: 2, text: "Figma", src: IMAGES.IconFigma },
  { id: 3, text: "HTML", src: IMAGES.IconHtml },
  { id: 4, text: "Insta", src: IMAGES.IconInsta },
  { id: 5, text: "Java", src: IMAGES.IconJava },
  { id: 6, text: "Javascript", src: IMAGES.IconJs },
  { id: 7, text: "LinkedIn", src: IMAGES.IconLinkedIn },
  { id: 8, text: "Node.js", src: IMAGES.IconNode },
  { id: 9, text: "Node Package Manager", src: IMAGES.IconNpm },
  { id: 10, text: "Python", src: IMAGES.IconPython },
  { id: 11, text: "React", src: IMAGES.IconReact },
  { id: 12, text: "SQL", src: IMAGES.IconSql },
  { id: 13, text: "Terraform", src: IMAGES.IconTf },
  { id: 14, text: "Typescript", src: IMAGES.IconTs },
  { id: 15, text: "Visual Studio Code", src: IMAGES.IconVs },
];
